
.pageContent {
  padding: 2rem;
}

.loader {
  background: var(--static-text-weak);
  height: 30px;
  width: 100px;
  border-radius: 10px;
}

.statLoader {
  background: var(--static-text-weak);
  height: 24px;
  width: 50px;
  border-radius: 20px;
}

.cardsContainer {
  display: grid;
  gap: 1rem;
  padding-bottom: 2rem;
  grid-template-columns: repeat(4, minmax(0px, 1fr));
}

.card {
  display: flex;
  flex-direction: column;
  padding: 1.25rem 1.5rem 1rem;
  background-color: var(--static-background-standard);
  border-radius: 0.75rem;
  border: 1px solid var(--static-divider-standard);
}

.cardLabel {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  color: var(--static-text-strong);
  font-weight: 500;
  padding-bottom: 1rem;
}

.cardValue {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  font-size: var(--fs-small-heading);
  color: var(--static-text-strong);
  font-weight: 500;
}

.dividerContainer {
  padding: 1rem 0px;
}

.divider {
  width: 100%;
  height: 1px;
  background-color: var(--static-divider-standard);
  margin: 0.5rem 0px 0.25rem;
}

.cardStatContainer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.25rem 0px;
}

.cardStatLabel {
  color: var(--static-text-standard);
  font-weight: normal;
}

.cardStatValue {
  color: var(--static-text-strong);
  font-weight: normal;
}

.ctaContainer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 1.5rem;
}

.containerTimeStamp {
  margin-top: 1rem;
}
